import * as _ from 'lodash'
import React, { useEffect, useMemo } from 'react';
import * as actions from '../actions';
import util from '../util';
import * as contractorActions from '../contractorActions';
import * as jobCostActions from '../jobCostActions';
import * as reportActions from '../reportActions';
import jobCostFactory, { IJobCost } from '../models/jobCostModel';
import changeOrderFactory from '../models/changeOrderModel';
import contractProxy from '../models/contractProxy';
import componentServices from '../componentServices';
import enums from '../enum';
import globalRelay from '../globalRelay';
import { useSaveRoot } from '../saveRoot';
import {
	JobCostEditSetup,
	JobCostEditReferralFee,
	JobCostEditProposal,
	JobCostEditWorkAreas,
	JobCostEditAccessoriesMods,
	JobCostEditApplianceSpecs,
	JobCostEditCabinetCost,
	JobCostEditGlass,
	JobCostEditSolidSurfaceCounter,
	JobCostEditInstallationService,
	JobCostEditSubTrades,
	JobCostEditDelivery,
	JobCostEditSummary,
	JobCostEditContract,
	JobCostEditFiles,
	JobCostEditReports,
	JobCostEditUpgrades,
	JobCostEditFinalize,
	JobCostEditFinalizeChangeOrder,
	JobCostEditSubmit,
	JobCostEditSubmitChangeOrder,
	JobCostEditSubmitBillingAdjustment,
	JobCostEditPreOrder,
	JobCostEditReview
} from './jobCostEditViews';
import JobCostSummary from '../models/jobCostSummary';
import JobSearchForm from './jobSearchForm';
import { Confirm, ContractorLockSection, Popup, JobSearchResults, Spinner, ViewPager } from './sharedComponents';
import { getModel, ModelCollection, StoreInstance } from 'Scripts/store';
import { IPatchOperation } from 'Scripts/modelFactory';
import { getInstallSheets, jobCostSchemaVersionCheck } from 'Scripts/schemaHelper';

const globalConfig = globalRelay.config!;
const _searchKey = 'jobcost-copy-to-jobs-search';

const AlertSuccess = ({ title, message, cancelLabel, confirmLabel, cancelHandler, confirmHandler }) => {
	const buttons:JSX.Element[] = [];

	buttons.push(<button key="cancel" onClick={ cancelHandler }><span>{ cancelLabel || 'Cancel'}</span></button>);
	buttons.push(<button key="confirm" onClick={ confirmHandler }><span>{ confirmLabel || 'OK'}</span></button>);

	return (
		<div className="alert success">
			<section>
				<header><span>{title}</span></header>
				<div className="content">
					{message}
					<div className="actions">
						{buttons}
					</div>
				</div>
			</section>
		</div>
	);
};

class RenameJobCost extends React.PureComponent<any,any> {
	constructor (props) {
		super(props);

		this.handlePreviousClick = this.handlePreviousClick.bind(this);
		this.handleInputChange = this.handleInputChange.bind(this);
	}

	handlePreviousClick (e) {
		e.preventDefault();

		this.props.back();
	}

	handleInputChange (e) {
		this.props.setJobCostName(e.target.value);
	}

	render () {
		const { name, typeName } = this.props;

		return (
			<section>
				<header>
					<span className="centered">{ `Name the ${typeName} Copy` }</span>
					<button className="icon iconOnly previous" onClick={ this.handlePreviousClick }><span /></button>
				</header>
				<section>
					<table className="half centered" cellPadding="0" cellSpacing="0">
						<tbody>
							<tr className="">
								<td />
								<td><strong>{ `${typeName} Name` }</strong></td>
								<td><input type="text" className="" placeholder="Enter a Name" autoCapitalize="" autoCorrect="off" value={util.reactVal(name)} onChange={this.handleInputChange}/></td>
								<td />
							</tr>
						</tbody>
					</table>
				</section>
			</section>
		);
	}
}

class ExistingJobSearch extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.state = this.getStateFromProps();

		this.previousHandler = this.previousHandler.bind(this);
		this.setTargetJobKeyHandler = this.setTargetJobKeyHandler.bind(this);
		this.setJobCostNameHandler = this.setJobCostNameHandler.bind(this);
		this.handleCopyClick = this.handleCopyClick.bind(this);
		this.handleCancelCopyClick = this.handleCancelCopyClick.bind(this);
	}

	getStateFromProps () {
		const state = _.assign({ viewIndex: 0, targetJobName: '' }, this.state);

		return state;
	}

	previousHandler () {
		const newIndex = Math.max(0, this.state.viewIndex - 1);
		this.setState({ targetJobKey: undefined, viewIndex: newIndex });
	}

	setTargetJobKeyHandler (key) {
		const viewIndex = this.state.viewIndex + 1;

		this.setState({ targetJobKey: key, viewIndex: viewIndex });
	}

	setJobCostNameHandler (name) {
		this.setState({ targetJobName: name });
	}

	handleCancelCopyClick () {
		actions.popModal();
	}

	handleCopyClick () {
		const destinationJobKey = this.state.targetJobKey;
		const destinationJobName = this.state.targetJobName;

		this.props.copyHandler(destinationJobKey, destinationJobName);
	}

	render () {
		const { typeName } = this.props;
		const searchResults = componentServices.store.getIn(['viewState', 'searchResults', _searchKey]);
		const classes = ['content', 'in', 'scrollable'].concat(this.props.classes);
		let resultsSection;
		const views:JSX.Element[] = [];
		const alerts = [];

		if (searchResults) {
			resultsSection = (<JobSearchResults
				list={ searchResults.list }
				parameterName={ searchResults.searchParameter.name }
				searchText= { searchResults.searchText }
				onJobClick= { (j) => this.setTargetJobKeyHandler(j.key) }
				nonExpanding={true} />);
		}

		views.push(<div className={classes.join(' ')}>
			<section>
				<header><span className="centered">Find Existing Job</span></header>
				<section className="inner">
					<JobSearchForm searchKey={ _searchKey } />
				</section>
				{resultsSection}
			</section>
		</div>);

		const renameView = (<RenameJobCost setJobCostName={ this.setJobCostNameHandler } back={ this.previousHandler } name={this.state.targetJobName} typeName={ typeName } />);
		views.push(renameView);

		const disableEntry = ((this.state.viewIndex === 0) || (this.state.targetJobName === '')) ? 'action save disabled' : 'action save';

		return (
			<div className="window">
				<header>
					<button key="cancel" className="cancel" onClick={this.handleCancelCopyClick}><span>Cancel</span></button>
					<span>{ `Copy ${typeName} to Another Job` }</span>
					<button key="save" className={ disableEntry } onClick={this.handleCopyClick}><span>Copy</span></button>
				</header>
				<ViewPager currentIndex={ this.state.viewIndex } views={views} alerts={alerts} />
			</div>
		);
	}
}

class SidebarActionsPopup extends React.PureComponent<any, any> {
	constructor (props) {
		super(props);
	}

	handleClick (button, e) {
		e.preventDefault();

		actions.popModal();

		button.action();
	}

	render () {
		const { buttons, target } = this.props;
		const windowSize = componentServices.store.getIn(['viewState', 'metrics', 'windowSize']).toJS();
		const rows = _.map(buttons, button => {
			return <li key={ button.label }><a className={ button.className } onClick={this.handleClick.bind(this, button)}><span>{ button.label }</span></a></li>;
		});

		return (
			<Popup isVertical={true} target={ target } windowSize={ windowSize }>
				<div className="content scrollable">
					<ul className="menu">
						{ rows }
					</ul>
				</div>
			</Popup>
		);
	}
}

const SidebarStatus = ({ summary }) => {
	const { routeParams } = componentServices;
	const isCompositeMode = routeParams.viewmode === 'composite';
	const config = globalConfig.withVariant(summary.jobCost.companyVariant);
	const totalSell = isNaN(summary.grandTotalSell) ? 0 : summary.grandTotalSell;
	const sellDisplay = '$' + (totalSell < 1000 ? totalSell.toFixed(0) : ((totalSell / 1000).toFixed(1) + 'K'));
	const label = ['unlocked', 'rejected'].indexOf(summary.jobCost.currentStatus) !== -1 ? 'TOTAL SO FAR' : 'TOTAL';
	const badgeColor = isCompositeMode? 'rgb(98, 151, 40)': config.badge.color;
	const badgeLabel = isCompositeMode? `${config.badge.label} - Composite`: config.badge.label;
	const badge = config.variants.length > 1 && config.badge ? <span className="badge" style={{ backgroundColor: badgeColor }}><span>{ badgeLabel }</span></span> : null;

	return	(<div className="stats clearfix">
		<div className="cost column">
			{ sellDisplay }<span>{ label }</span>
			{ badge }
		</div>
	</div>);
};

class SidebarNavItem extends React.PureComponent<any,any> {
	handleClick (item, e) {
		e.preventDefault();
		this.props.handleNavClick(item);
	}

	render () {
		const { isChangeOrder, navItem } = this.props;
		const classNames = ['button'];
		const statusLabel = '';

		if (isChangeOrder) {
			classNames.push('changes');
		}

		if (navItem.hasChanges) {
			classNames.push('hasChange');
		}

		if (navItem.isDisabled) {
			classNames.push('disabled');
		}

		if (navItem.hasData) {
			classNames.push('hasData');
		}

		if (navItem.isLocked) {
			classNames.push('locked');
		}

		// Check if this is the currently selected item now
		if (this.props.selected) {
			classNames.push('on');
		}

		return (
			//<li><a className={classNames.join(' ')} onClick={this.handleClick}><span>{navItem.title}</span><em className="status">{statusLabel}</em></a></li>
			// TODO (TSF) -
			<li><a className={classNames.join(' ')} onClick={this.handleClick.bind(this, navItem)} title={ navItem.tip || navItem.title }><span>{navItem.title}</span><em className="status">{statusLabel}</em></a></li>

		);
	}
}

const SidebarNav = ({ navItems, currentNavItem, handleNavClick, jobCost }) => {
	const isChangeOrder = !!jobCost.currentChangeOrder;
	const children = _.map(navItems, item => {
		const isSelected = (item === currentNavItem);

		return <SidebarNavItem navItem={item} selected={isSelected} handleNavClick={handleNavClick} key={item.key} isChangeOrder={ isChangeOrder }/>;
	});

	return (<div className="scrollable">
		<ul className="menu">
			{children}
		</ul>
	</div>);
};

const WORKFLOW_FILTERS = {
	isChange: ({ jobCost }) => !!jobCost.currentChangeOrder,
	isNotChange: ({ jobCost }) => !jobCost.currentChangeOrder,
	isChangeOrder: ({ jobCost }) => WORKFLOW_FILTERS.isChange({ jobCost }) && jobCost.currentChangeOrder.type === 'change-order',
	isBillingAdjustment: ({ jobCost }) => WORKFLOW_FILTERS.isChange({ jobCost }) && jobCost.currentChangeOrder.type === 'billing-adjustment',
	isNotBillingAdjustment: ({ jobCost }) => WORKFLOW_FILTERS.isNotChange({ jobCost }) || jobCost.currentChangeOrder.type === 'change-order',
	isNotTemplate: ({ jobCost }) => !!jobCost.jobKey,
	changeOrderCannotBeEditedAndHasNoChanges: ({ jobCost, hasChanges }) => !!jobCost.currentChangeOrder && jobCost.allowedContractEdits === 'none' && !hasChanges,
	isFilteredByConfig: ({ key, excludedKeys, includedKeys, isOptional = false }) => excludedKeys.indexOf(key) !== -1 || (isOptional && includedKeys.indexOf(key) === -1)
};

// returning undefined from a factory will exclude the item from the nav
const WORKFLOW_FACTORIES = [{
	create: ({ excludedKeys, hasSetup, includedKeys, jobCost }) => {
		const key = 'setup';
		let isLocked = jobCost.allowedContractEdits === 'none';
		if (!WORKFLOW_FILTERS.isFilteredByConfig({ key, excludedKeys, includedKeys })) {
			
			if (WORKFLOW_FILTERS.isChangeOrder({ jobCost })) {
				isLocked = jobCost.allowedContractEdits === 'none' && jobCost.currentChangeOrder.currentStatus!== 'closed';
			}

			return {
				key,
				title: 'Setup',
				component: <JobCostEditSetup />,
				hasData: hasSetup,
				hasChanges: hasSetup,
				isDisabled: false,
				isLocked: isLocked
			};
		}
	}
}, {
	create: ({ changeOrderKey, excludedKeys, hasSetup, includedKeys, jobCost }) => {
		const key = 'referral-fee';
		const lineItems = jobCost.getLineItemsByType(['referral-fee']);
		const hasChanges = _.some(lineItems, i => i.isChange && i.changeOrderKey === changeOrderKey);

		if (!WORKFLOW_FILTERS.isFilteredByConfig({ key, excludedKeys, includedKeys }) && WORKFLOW_FILTERS.isNotTemplate({ jobCost }) && !WORKFLOW_FILTERS.changeOrderCannotBeEditedAndHasNoChanges({ jobCost, hasChanges })) {
			return {
				key,
				title: 'Referral Fee',
				component: <JobCostEditReferralFee />,
				hasData: !!(lineItems && lineItems.length),
				hasChanges,
				isDisabled: !hasSetup,
				isLocked: jobCost.allowedContractEdits === 'none' || !hasSetup
			};
		}
	}
}, {
	create: ({ excludedKeys, hasSetup, includedKeys, jobCost }) => {
		const key = 'proposal';

		if (!WORKFLOW_FILTERS.isFilteredByConfig({ key, excludedKeys, includedKeys, isOptional: true }) && WORKFLOW_FILTERS.isNotTemplate({ jobCost }) && !jobCost.currentChangeOrder) {
			return {
				key,
				title: 'Proposal',
				component: <JobCostEditProposal />,
				hasData: !!jobCost.proposal,
				hasChanges: false,
				isDisabled: !hasSetup,
				isLocked: jobCost.allowedContractEdits === 'none' || !hasSetup
			};
		}
	}
}, {
	create: ({ changes, excludedKeys, hasSetup, includedKeys, hasWorkAreas, jobCost }) => {
		const key = 'work-area-specs';
		const hasChanges = !!changes.spec.length;

		if (!WORKFLOW_FILTERS.isFilteredByConfig({ key, excludedKeys, includedKeys }) && WORKFLOW_FILTERS.isNotBillingAdjustment({ jobCost }) && !WORKFLOW_FILTERS.changeOrderCannotBeEditedAndHasNoChanges({ jobCost, hasChanges })) {
			return {
				key,
				title: 'Work Area Specs',
				component: <JobCostEditWorkAreas />,
				hasData: hasWorkAreas,
				hasChanges,
				isDisabled: !hasSetup,
				isLocked: jobCost.allowedContractEdits === 'none' || !hasSetup
			};
		}
	}
}, {
	create: ({ changeOrderKey, excludedKeys, hasSetup, includedKeys, hasWorkAreas, jobCost }) => {
		const key = 'accessories-mods';
		const lineItems = jobCost.getLineItemsByType(['outside-supplier', 'warehouse', 'misc']);
		const hasChanges = _.some(lineItems, i => i.isChange && i.changeOrderKey === changeOrderKey);

		if (!WORKFLOW_FILTERS.isFilteredByConfig({ key, excludedKeys, includedKeys }) && WORKFLOW_FILTERS.isNotBillingAdjustment({ jobCost }) && !WORKFLOW_FILTERS.changeOrderCannotBeEditedAndHasNoChanges({ jobCost, hasChanges })) {
			return {
				key,
				title: 'Accessories & Mods',
				component: <JobCostEditAccessoriesMods />,
				hasData: !!(lineItems && lineItems.length),
				hasChanges,
				isDisabled: !hasSetup || !hasWorkAreas,
				isLocked: jobCost.allowedContractEdits === 'none' || !hasSetup || !hasWorkAreas
			};
		}
	}
}, {
	create: ({ changes, excludedKeys, hasSetup, includedKeys, hasWorkAreas, jobCost }) => {
		const key = 'appliance-specs';
		const hasChanges = !!changes.appliance.length;

		if (!WORKFLOW_FILTERS.isFilteredByConfig({ key, excludedKeys, includedKeys }) && WORKFLOW_FILTERS.isNotBillingAdjustment({ jobCost }) && !WORKFLOW_FILTERS.changeOrderCannotBeEditedAndHasNoChanges({ jobCost, hasChanges })) {
			return {
				key,
				title: 'Appliance Specs',
				component: <JobCostEditApplianceSpecs />,
				hasData: !!_.filter(jobCost.specifications, spec => spec.group === enums.specGroups.Appliance).length,
				hasChanges,
				isDisabled: !hasSetup || !hasWorkAreas,
				isLocked: jobCost.allowedContractEdits === 'none' || !hasSetup || !hasWorkAreas
			};
		}
	}
}, {
	create: ({ changeOrderKey, excludedKeys, hasSetup, includedKeys, hasWorkAreas, jobCost }) => {
		const key = 'cabinets';
		const lineItems = jobCost.getLineItemsByType(['cabinet']);
		const hasChanges = _.some(lineItems, i => i.isChange && i.changeOrderKey === changeOrderKey);

		if (!WORKFLOW_FILTERS.isFilteredByConfig({ key, excludedKeys, includedKeys }) && WORKFLOW_FILTERS.isNotBillingAdjustment({ jobCost }) && !WORKFLOW_FILTERS.changeOrderCannotBeEditedAndHasNoChanges({ jobCost, hasChanges })) {
			return {
				key,
				title: 'Cabinet Cost',
				component: <JobCostEditCabinetCost />,
				hasData: !!(lineItems && lineItems.length),
				hasChanges,
				isDisabled: !hasSetup || !hasWorkAreas,
				isLocked: jobCost.allowedContractEdits === 'none' || !hasSetup || !hasWorkAreas
			};
		}
	}
}, {
	create: ({ changeOrderKey, excludedKeys, hasSetup, includedKeys, hasWorkAreas, jobCost }) => {
		const key = 'glass';
		const lineItems = jobCost.getLineItemsByType(['glass', 'special-order-glass']);
		const hasChanges = _.some(lineItems, i => i.isChange && i.changeOrderKey === changeOrderKey);

		if (!WORKFLOW_FILTERS.isFilteredByConfig({ key, excludedKeys, includedKeys }) && WORKFLOW_FILTERS.isNotBillingAdjustment({ jobCost }) && !WORKFLOW_FILTERS.changeOrderCannotBeEditedAndHasNoChanges({ jobCost, hasChanges })) {
			return {
				key,
				title: 'Glass',
				component: <JobCostEditGlass />,
				hasData: !!(lineItems && lineItems.length),
				hasChanges,
				isDisabled: !hasSetup || !hasWorkAreas,
				isLocked: jobCost.allowedContractEdits === 'none' || !hasSetup || !hasWorkAreas
			};
		}
	}
}, {
	create: ({ changeOrderKey, builder, excludedKeys, hasSetup, includedKeys, hasBuilder, hasWorkAreas, jobCost }) => {
		const key = 'solid-surface-counter';
		const lineItems = jobCost.getLineItemsByType(['solid-surface-counter']);
		const hasChanges = _.some(lineItems, i => i.isChange && i.changeOrderKey === changeOrderKey);

		if (!WORKFLOW_FILTERS.isFilteredByConfig({ key, excludedKeys, includedKeys }) && WORKFLOW_FILTERS.isNotTemplate({ jobCost }) && WORKFLOW_FILTERS.isNotBillingAdjustment({ jobCost }) && !WORKFLOW_FILTERS.changeOrderCannotBeEditedAndHasNoChanges({ jobCost, hasChanges }) && (!hasBuilder || (builder && (builder.type & (enums.contractorTypes.Retail_Builder | enums.contractorTypes.Renovation_Contractor)) !== 0))) {
			return {
				key,
				title: 'Solid Surface Counter',
				component: <JobCostEditSolidSurfaceCounter />,
				hasData: !!(lineItems && lineItems.length),
				hasChanges,
				isDisabled: !hasSetup || !hasWorkAreas,
				isLocked: jobCost.allowedContractEdits === 'none' || !hasSetup || !hasWorkAreas
			};
		}
	}
}, {
	expand: ({ jobCost, workflowItems }) => {
		if (jobCost.installationMode !== 'none' && (!jobCost.currentChangeOrder || jobCost.currentChangeOrder.type === 'change-order')) {
			const installSheets = getInstallSheets(jobCost)
			const sheetCount = installSheets.length();

			_.forEach(_.sortBy(installSheets, ['sortIndex']), sheet => {
				workflowItems.push({
					create: ({ changeOrderKey, excludedKeys, hasSetup, includedKeys, hasWorkAreas }) => {
						const key = `installation-service-${sheet.sortIndex + 1}`;
						const lineItems = _.filter(jobCost.getLineItemsByType(['installation', 'installation-custom', 'service', 'travel']), { installSheetKey: sheet.key });
						const hasChanges = _.some(lineItems, i => i.isChange && i.changeOrderKey === changeOrderKey);

						if (!WORKFLOW_FILTERS.isFilteredByConfig({ key, excludedKeys, includedKeys }) && WORKFLOW_FILTERS.isNotBillingAdjustment({ jobCost }) && !WORKFLOW_FILTERS.changeOrderCannotBeEditedAndHasNoChanges({ jobCost, hasChanges })) {
							return {
								key,
								title: sheetCount > 1 ? `Installation & Service ${sheet.sortIndex + 1}` : 'Installation & Service', tip: sheetCount > 1 ? sheet.name : 'Installation & Service',
								component: <JobCostEditInstallationService key={ `${jobCost.key}-${key}`} />,
								hasData: !!(lineItems && lineItems.length),
								hasChanges,
								isDisabled: !hasSetup || !hasWorkAreas,
								isLocked: jobCost.allowedContractEdits === 'none' || !hasSetup || !hasWorkAreas,
								props: { installSheetKey: sheet.key }
							};
						}
					}
				});
			});
		}
	}
}, {
	create: ({ changeOrderKey, excludedKeys, hasBuilder, hasSetup, includedKeys, hasWorkAreas, jobCost }) => {
		const key = 'sub-trades';
		const lineItems = jobCost.getLineItemsByType(['subtrade']);
		const hasChanges = _.some(lineItems, i => i.isChange && i.changeOrderKey === changeOrderKey);

		if (!WORKFLOW_FILTERS.isFilteredByConfig({ key, excludedKeys, includedKeys }) && WORKFLOW_FILTERS.isNotTemplate({ jobCost }) && !hasBuilder && WORKFLOW_FILTERS.isNotBillingAdjustment({ jobCost }) && !WORKFLOW_FILTERS.changeOrderCannotBeEditedAndHasNoChanges({ jobCost, hasChanges })) {
			return {
				key,
				title: 'Sub Trades',
				component: <JobCostEditSubTrades />,
				hasData: !!(lineItems && lineItems.length),
				hasChanges,
				isDisabled: !hasSetup || !hasWorkAreas,
				isLocked: jobCost.allowedContractEdits === 'none' || !hasSetup || !hasWorkAreas
			};
		}
	}
}, {
	create: ({ changeOrderKey, excludedKeys, hasSetup, includedKeys, hasWorkAreas, jobCost }) => {
		const key = 'delivery';
		const lineItems = jobCost.getLineItemsByType(['delivery']);
		const hasChanges = _.some(lineItems, i => i.isChange && i.changeOrderKey === changeOrderKey);

		if (!WORKFLOW_FILTERS.isFilteredByConfig({ key, excludedKeys, includedKeys }) && WORKFLOW_FILTERS.isNotBillingAdjustment({ jobCost }) && !WORKFLOW_FILTERS.changeOrderCannotBeEditedAndHasNoChanges({ jobCost, hasChanges })) {
			return {
				key,
				title: 'Delivery',
				component: <JobCostEditDelivery />,
				hasData: !!(lineItems && lineItems.length),
				hasChanges,
				isDisabled: !hasSetup || !hasWorkAreas,
				isLocked: jobCost.allowedContractEdits === 'none' || !hasSetup || !hasWorkAreas
			};
		}
	}
}, {
	create: ({ changeOrderKey, excludedKeys, hasBuilder, hasSetup, includedKeys, hasWorkAreas, jobCost }) => {
		const key = 'upgrades';
		const lineItems = jobCost.getLineItemsByType(['builder-upgrade', 'client-upgrade']);
		const hasChanges = _.some(lineItems, i => i.isChange && i.changeOrderKey === changeOrderKey);

		if (!WORKFLOW_FILTERS.isFilteredByConfig({ key, excludedKeys, includedKeys }) && !!hasBuilder && WORKFLOW_FILTERS.isNotChange({ jobCost }) && !WORKFLOW_FILTERS.changeOrderCannotBeEditedAndHasNoChanges({ jobCost, hasChanges })) {
			return {
				key,
				title: 'Upgrades',
				component: <JobCostEditUpgrades />,
				hasData: !!(lineItems && lineItems.length),
				hasChanges,
				isDisabled: !hasSetup || !hasWorkAreas,
				isLocked: jobCost.allowedContractEdits === 'none' || !hasSetup || !hasWorkAreas
			};
		}
	}
}, {
	create: ({ changes, excludedKeys, hasSetup, hasWorkAreas, includedKeys, jobCost }) => {
		const key = 'summary';

		if (!WORKFLOW_FILTERS.isFilteredByConfig({ key, excludedKeys, includedKeys }) && WORKFLOW_FILTERS.isNotBillingAdjustment({ jobCost })) {
			const isDisabled = !hasSetup || !hasWorkAreas;

			return {
				key,
				title: 'Summary',
				component: <JobCostEditSummary />,
				hasData: false,
				hasChanges: !!changes.lineItem.length || !!changes.spec.length || !!changes.appliance.length,
				isDisabled,
				isLocked: jobCost.allowedContractEdits === 'none' || isDisabled
			};
		}
	}
}, {
	create: ({ changes, excludedKeys, hasSetup, hasWorkAreas, includedKeys, jobCost }) => {
		const key = 'reports';

		if (!WORKFLOW_FILTERS.isFilteredByConfig({ key, excludedKeys, includedKeys }) && WORKFLOW_FILTERS.isNotBillingAdjustment({ jobCost })) {
			const isDisabled = !hasSetup || !hasWorkAreas;

			return {
				key,
				title: 'Reports',
				component: <JobCostEditReports />,
				hasData: false,
				hasChanges: !!changes.lineItem.length || !!changes.spec.length || !!changes.appliance.length,
				isDisabled,
				isLocked: jobCost.allowedContractEdits === 'none' || isDisabled
			};
		}
	}
}, {
	create: ({ changes, excludedKeys, hasSetup, hasWorkAreas, includedKeys, jobCost }) => {
		const key = 'files';

		if (!WORKFLOW_FILTERS.isFilteredByConfig({ key, excludedKeys, includedKeys }) && WORKFLOW_FILTERS.isNotTemplate({ jobCost })) {
			const isDisabled = !hasSetup || !hasWorkAreas;

			return {
				key,
				title: 'Files',
				component: <JobCostEditFiles />,
				hasData: false,
				hasChanges: !!changes.lineItem.length || !!changes.spec.length || !!changes.appliance.length,
				isDisabled,
				isLocked: isDisabled
			};
		}
	}
}, {
	create: ({ changes, excludedKeys, hasSetup, hasWorkAreas, includedKeys, jobCost }) => {
		const key = 'finalize';

		if (!WORKFLOW_FILTERS.isFilteredByConfig({ key, excludedKeys, includedKeys }) && WORKFLOW_FILTERS.isNotTemplate({ jobCost }) && WORKFLOW_FILTERS.isNotBillingAdjustment({ jobCost })) {
			const isDisabled = !hasSetup || !hasWorkAreas;

			return {
				key,
				title: 'Finalize',
				component: WORKFLOW_FILTERS.isNotChange({ jobCost }) ? <JobCostEditFinalize /> : <JobCostEditFinalizeChangeOrder />,
				hasData: false,
				hasChanges: !!changes.lineItem.length || !!changes.spec.length || !!changes.appliance.length,
				isDisabled,
				isLocked: jobCost.allowedContractEdits === 'none' || isDisabled
			};
		}
	}
}, {
	create: ({ changes, currentStatus, excludedKeys, hasSetup, hasWorkAreas, includedKeys, jobCost, routeParams }) => {
		const key = 'contract';

		//contracts should be included in the composite contract nav
		if (/*routeParams.viewmode !== 'composite' &&*/ !WORKFLOW_FILTERS.isFilteredByConfig({ key, excludedKeys, includedKeys }) && WORKFLOW_FILTERS.isNotTemplate({ jobCost }) && WORKFLOW_FILTERS.isNotBillingAdjustment({ jobCost })) {
			const isDisabled = routeParams.moduleKey !== 'order-desk' && (!hasSetup || !hasWorkAreas || ['unlocked', 'rejected', 'closed'].indexOf(currentStatus) !== -1);
			return {
				key,
				title: 'Contract',
				component: <JobCostEditContract />,
				hasData: false,
				hasChanges: !!changes.lineItem.length || !!changes.spec.length || !!changes.appliance.length,
				isDisabled: isDisabled,
				isLocked: jobCost.allowedContractEdits === 'none' || isDisabled
			};
		}
	}
}, {
	create: ({ changes, currentStatus, excludedKeys, hasSetup, hasWorkAreas, includedKeys, jobCost, routeParams }) => {
		const key = 'submit';

		if (!WORKFLOW_FILTERS.isFilteredByConfig({ key, excludedKeys, includedKeys }) && WORKFLOW_FILTERS.isNotTemplate({ jobCost }) && routeParams.modulekey !== 'order-desk') {
			let isDisabled = (!hasSetup || !hasWorkAreas || ['unlocked', 'rejected', 'closed'].indexOf(currentStatus) !== -1);
			let component = <JobCostEditSubmit />;

			if (WORKFLOW_FILTERS.isChangeOrder({ jobCost })) {
				component = <JobCostEditSubmitChangeOrder />;
			}
			else if (WORKFLOW_FILTERS.isBillingAdjustment({ jobCost })) {
				isDisabled = !hasSetup;
				component = <JobCostEditSubmitBillingAdjustment />;
			}

			return {
				key,
				title: 'Submit',
				component,
				hasData: false,
				hasChanges: !!changes.lineItem.length || !!changes.spec.length || !!changes.appliance.length,
				isDisabled,
				isLocked: jobCost.allowedContractEdits !== 'none' ? isDisabled : ['locked', 'rejected'].indexOf(currentStatus) === -1
			};
		}
	}
}, {
	create: ({ changes, excludedKeys, hasSetup, hasWorkAreas, includedKeys, jobCost, routeParams }) => {
		const key = 'pre-order';

		if (!WORKFLOW_FILTERS.isFilteredByConfig({ key, excludedKeys, includedKeys, isOptional: true }) && WORKFLOW_FILTERS.isNotTemplate({ jobCost }) && routeParams.modulekey === 'order-desk') {
			const isDisabled = !hasSetup || !hasWorkAreas;
			return {
				key,
				title: 'Pre-Order',
				component: <JobCostEditPreOrder />,
				hasData: false,
				hasChanges: !!changes.lineItem.length || !!changes.spec.length || !!changes.appliance.length,
				isDisabled: isDisabled,
				isLocked: isDisabled || jobCost.currentStatus !== 'pending-approval' || !!jobCost.preorderSubmittedDate
			};
		}
	}
}, {
	create: ({ changes, excludedKeys, hasSetup, hasWorkAreas, includedKeys, jobCost, routeParams }) => {
		const key = 'review';

		if (!WORKFLOW_FILTERS.isFilteredByConfig({ key, excludedKeys, includedKeys }) && WORKFLOW_FILTERS.isNotTemplate({ jobCost }) && routeParams.modulekey === 'order-desk') {
			const supportsPreview = includedKeys.indexOf('pre-order') !== -1;
			const isDisabled = (supportsPreview && !jobCost.preorderSubmittedDate) || !hasSetup || !hasWorkAreas;
			return {
				key,
				title: 'Review',
				component: <JobCostEditReview />,
				hasData: false,
				hasChanges: !!changes.lineItem.length || !!changes.spec.length || !!changes.appliance.length,
				isDisabled: isDisabled,
				isLocked: isDisabled || jobCost.currentStatus !== 'pending-approval'
			};
		}
	}
}];

type JobCostLineUpdateCallback = (childItem, path?: string, deleted?: boolean) => void;

export interface IJobCostChildProps {
	jobCost?: IJobCost;
	updateModel?: (updater: (jobCost: IJobCost, lineUpdateCallback: JobCostLineUpdateCallback) => void, options: Record<string, any>) => void;
	fetchReport?: (reportPath: string, shaper?) => Promise<void | Blob>;
	store?: StoreInstance;
	typeName?: string;
	summary?: JobCostSummary
}

let _postSaveCallback;
export default function JobCostEdit(props) {
	const { routeParams, store } = componentServices;
	const jobKey = routeParams.jobkey;
	const isCompositeMode = routeParams.viewmode === 'composite';
	const changeOrderKey = routeParams.changeorderkey;
	const changeOrderTypeParam = routeParams.changeordertype;
	const getChangeOrder = jc => {
		if(!jc) {
			return undefined;
		}

		//temp: passing schemaVersion from JC for install sheet schemaVersion = 2 issues
		return changeOrderKey ? jc.changeOrders.get(changeOrderKey) || changeOrderFactory({ key: changeOrderKey, type: changeOrderTypeParam, requiresDelivery: true, requiresInstall: true }) : undefined;
	};
	const [saveRoot] = useSaveRoot<IJobCost>({
		autoSave:  true,
		globalSave: true,
		warnOnLeave: true,
		stateId: `JobCostEdit-${routeParams.jobcostkey}`,
		modelFactory: jobCostFactory,
		resolveMutableModel(current: IJobCost | null) {
			const { securityContext } = componentServices;
			const contractorKey = routeParams.contractorkey;
			const currentModule = routeParams.modulekey;
			const key = routeParams.jobcostkey;
			const storeJobCost = getModel({ store: componentServices.store, collection: ModelCollection.jobCosts, key });
			const changeOrder = getChangeOrder(storeJobCost);
			const canEditLockedJobCost = securityContext.currentUserHasFeature(currentModule, 'edit-locked-jobcost') && storeJobCost.changeOrders.length() === 0;
			let jobCost = current;
			let rebase = false;

			if (storeJobCost) {
				let factory = () => jobCostFactory(storeJobCost.toDocument());

				if(isCompositeMode) {
					factory = () => contractProxy(storeJobCost, changeOrder, false);
				}
				else if(changeOrder) {
					factory = () => contractProxy(storeJobCost, changeOrder, changeOrder.allowedContractEdits === 'none');
				}
				else if(storeJobCost.allowedContractEdits === 'none') {
					factory = () => contractProxy(storeJobCost, changeOrder, !canEditLockedJobCost);
				}
				
				if (!current || storeJobCost.key !== current.key) {
					jobCost = factory();
				}
				else if (storeJobCost.key === current.key && storeJobCost.itemVersion !== current.itemVersion) {
					jobCost = factory();
					rebase = true;
				}
			}
			else if (!current) {
				const marginKey = currentModule && currentModule.split('-')[0];
				const margin = globalConfig.jobCostSettings.defaultMargin && globalConfig.jobCostSettings.defaultMargin[marginKey];
	
				// This is a new template
				if (contractorKey) {
					jobCost = jobCostFactory({ key, type: 'template', contractorKey, margin });
				}
				else {
					// this is a new estimate
					jobCost = jobCostFactory({ key, jobKey, margin });
				}
	
				globalRelay.triggerJobCostCreate(jobCost);
			}
			_ensureInstallationConfig(jobCost);

			// always be sure that the saveRoot is accessing the unproxied model so that patches are correctly diffed
			return [ jobCost.proxiedContract || jobCost, rebase ]
		},
		save: (doc, patch: IPatchOperation[]) => jobCostActions.saveJobCost({ jobCost: doc, patch }),
		savedCallback() {
			if (_postSaveCallback) {
				_postSaveCallback();
				_postSaveCallback = undefined;
			}
		},
		processAlert(alert) {
			alert.message = alert.message.replace(/Line Items \d+ is not valid\.\n/g, '');
			
			return alert;
		},
		validate(model ){
			return model.test() || [];
		}
	});

	useEffect(() => {
		if(isCompositeMode) {
			actions.setBanner({ type: 'attention', message: `You’re viewing a Composite Contract` });
		}

		return () => {
			actions.setBanner(null);
		}
	}, []);

	const { model: jobCost} = saveRoot;
	const job = jobKey ? getModel({ store, collection: ModelCollection.jobs, key: jobKey }) : null;
	const changeOrder = getChangeOrder(jobCost);
	let typeName = (jobCost?.type === 'template') ? 'Template' : 'Estimate';

	if (changeOrder) {
		typeName = _.startCase(changeOrder.type);
	}

	const summary = useMemo(() => {
		if(!jobCost) {
			return null;
		}
		const proxy = contractProxy(jobCost, changeOrder, !isCompositeMode);
		const paymentsKey = changeOrder && changeOrder.key || proxy.key;
		const result = new JobCostSummary(proxy, (job && job.getAppliedPaymentTotal(paymentsKey)) || 0);

		result.buildItems();

		return result;
	}, [job, jobCost, changeOrder])

	const navItems = useMemo(() => {
		// jobCost may not have currentChangeOrder populated or properly filtered lists, so use the proxy if one exists
		return buildNavItems(jobCost?.contractProxy || jobCost);
	}, [jobCost])

	function _ensureInstallationConfig (jobCost) {
		const configs:string[] = [];

		if (jobCost) {
			const config = globalConfig.withVariant(jobCost.companyVariant);

			if (config.jobCostSettings.installation.mode !== 'none') {
				const installConfigName = jobCost.getSettingValue(enums.jobCostSettingGroups.General, 'installationConfigDefinition', undefined, actions.formatConfigName(jobCost));
				configs.push(installConfigName);
			}
		}

		_.forEach(configs, c => {
			const installationConfig = componentServices.store.getIn(['model', 'config', _.camelCase(c)]);
			if (installationConfig === undefined) {
				actions.fetchConfig({ name: c });
			}
		});
	}

	function updateModel (updater, options) {
		saveRoot.update((jobCost) => {
			// the update target should always be the proxy to ensure that mutations are properly handled
			const updateTarget = jobCost.contractProxy || jobCost;
			const changeOrderKey = updateTarget.currentChangeOrder && updateTarget.currentChangeOrder.key;

			// delay adding the change order until we are here
			if (updateTarget.currentChangeOrder && !updateTarget.changeOrders.get(changeOrderKey)) {
				updateTarget.changeOrders.add(updateTarget.currentChangeOrder);
				//temp addition for install sheets for schemaVersion = 2 jobCosts
				jobCostSchemaVersionCheck(updateTarget,2) && updateTarget.installSheets.add({ jobCostKey: updateTarget.key, changeOrderKey: changeOrderKey, margin: updateTarget.margin, name: "Primary", sortIndex: 0, unitCost: updateTarget.installationUnitPrice })
			}

			updater(updateTarget, (childItem, path, deleted) => {
				const childModelName = childItem.getModelName();

				if (childModelName === 'JobCostLineItem') {
					if (!updateTarget.currentChangeOrder || childItem.changeOrderKey === changeOrderKey) {
						globalRelay.triggerJobCostLineUpdate(childItem, path, updateTarget, deleted);
					}
					else {
						const changeLine = _.find(updateTarget.lineItems, { rowKey: childItem.rowKey, changeOrderKey: changeOrderKey });

						if (changeLine) {
							globalRelay.triggerJobCostLineUpdate(changeLine, path, updateTarget, deleted);
						}
					}
				}
				else if (childModelName === 'JobCostSetting') {
					globalRelay.triggerJobCostSettingUpdate(childItem, updateTarget, deleted);
				}
				else if (childModelName === 'JobCostSpecification') {
					globalRelay.triggerJobCostSpecificationUpdate(childItem, updateTarget, deleted);
				}
			});

			// summary notes were slipping through with empty values, this is an attempt to ensure that can't happen
			const invalidNoteKeys = _.map(_.filter(jobCost.notes, n => !n.content), n => n.key);
			_.forEach(invalidNoteKeys, k => {
				jobCost.notes.delete(k);
			});

			if (options.autoSave) {
				// be sure that keystrokes don't trigger these
				globalRelay.triggerJobCostUpdate(updateTarget, summary, options.updatePath);
			}
		}, options);
	}

	function handleNavClick (item) {
		saveRoot.confirmLeave(proceed => {
			if (proceed) {
				componentServices.router.pushHistory(componentServices.router.replaceLastPathSegment(item.key));
				setTimeout(() => {
					actions.setScrollContentKey({ key: `jobCost/${item.key}}` });
				}, 50);
			}
		});
	}

	function buildNavItems (jobCost) {
		if (!jobCost) { return []; }

		const hasWorkAreas = (jobCost.workAreas && jobCost.workAreas.length() > 0);
		const changeOrderKey = jobCost.currentChangeOrder && jobCost.currentChangeOrder.key;
		const hasSetup = jobCost.currentChangeOrder ? (jobCost.currentChangeOrder.name && jobCost.currentChangeOrder.description) : (jobCost.name && jobCost.margin);
		const user = componentServices.securityContext.getCurrentUser();
		const currentStatus = (jobCost.currentChangeOrder && jobCost.currentChangeOrder.currentStatus) || jobCost.currentStatus;
		const config = globalConfig.withVariant(jobCost.companyVariant);
		const workflowItems:any[] = [];
		let hasBuilder = false;
		let job;
		let builder;

		if (jobCost.jobKey) {
			const { store } = componentServices;
			job = getModel({ store, collection: ModelCollection.jobs, key: jobCost.jobKey});

			if (job && job.builderKey) {
				builder = getModel({ store, collection: ModelCollection.contractors, key: job.builderKey});

				if (!builder) {
					contractorActions.fetchContractor({ key: job.builderKey });
				}

				hasBuilder = true;
			}
		}

		// 'expand' any items that provide it (installation & service)
		_.forEach(WORKFLOW_FACTORIES, item => {
			if (item.expand) {
				item.expand({ jobCost, workflowItems });
			}
			else {
				workflowItems.push(item);
			}
		});

		const itemParams = {
			builder,
			changes: {
				appliance: _.filter(jobCost.specifications, spec => spec.group === enums.specGroups.Appliance && spec.isChange),
				lineItem: _.filter(jobCost.lineItems, li => li.isChange && li.changeOrderKey === changeOrderKey),
				spec: _.filter(jobCost.specifications, spec => (spec.group === enums.specGroups.Cabinet || spec.group === enums.specGroups.Work_Area) && spec.isChange && spec.changeOrderKey === changeOrderKey)
			},
			changeOrderKey,
			currentStatus,
			excludedKeys: (config.jobCostSettings.workflow && config.jobCostSettings.workflow.excludedKeys) || [],
			globalConfig,
			hasBuilder,
			hasSetup,
			hasWorkAreas,
			includedKeys: (config.jobCostSettings.workflow && config.jobCostSettings.workflow.includedKeys) || [],
			job,
			jobCost,
			routeParams: componentServices.routeParams,
			user
		};

		return _.filter(_.map(workflowItems, item => {
			return item.create(itemParams);
		}), item => !!item);
	}

	// function handleNavigateToJob (e) {
	// 	e.preventDefault();

	// 	actions.popModal();
	// }

	// handleSelectJobState (state) {
	// 	this.setClient(state.contact);
	// }

	function gotoJobCost (jobCost, e) {
		e.preventDefault();

		// Dismiss the alert here
		actions.popModal();

		const segments = componentServices.router.getPathSegments();

		componentServices.router.replacePathSegmentAt(2, jobCost.jobKey || jobCost.contractorKey, false, segments);
		const path = componentServices.router.replacePathSegmentAt(4, jobCost.key, false, segments);

		componentServices.router.pushHistory(path);
	}

	function copyJobCostInContractor () {
		let newJobCost;

		actions.popModal();

		if (jobCost) {
			newJobCost = jobCost.clone();

			globalRelay.triggerJobCostCreate(newJobCost);
			jobCostActions.saveJobCost({ jobCost: newJobCost });

			const popup = <AlertSuccess title="Duplicated" message={ 'Would you like to view the duplicate now?' } confirmLabel="Yes" cancelLabel="No" cancelHandler={ actions.popModal } confirmHandler={ gotoJobCost.bind(undefined, newJobCost) } />;

			actions.pushModal({ component: popup });
		}
	}

	function copyJobCostToNewJob (targetJobKey, targetJobName) {
		let newJobCost;

		actions.popModal();

		if (jobCost) {
			newJobCost = jobCost.clone();
			newJobCost.jobKey = targetJobKey;
			newJobCost.name = targetJobName;

			globalRelay.triggerJobCostCreate(newJobCost);
			jobCostActions.saveJobCost({ jobCost: newJobCost });

			const popup = <AlertSuccess title={ `${typeName} Copied to Another Job` } message={ `Would you like to view the copied ${typeName} now?` } confirmLabel="Yes" cancelLabel="No" cancelHandler={ actions.popModal } confirmHandler={ gotoJobCost.bind(undefined, newJobCost) } />;

			actions.pushModal({ component: popup });
		}
	}

	function copyJobCostInJob () {
		let newJobCost;

		actions.popModal();

		if (jobCost) {
			newJobCost = jobCost.clone();

			globalRelay.triggerJobCostCreate(newJobCost);
			jobCostActions.saveJobCost({ jobCost: newJobCost });

			const popup = <AlertSuccess title={ `${typeName} Copied in This Job` } message={ `Would you like to view the copied ${typeName} now?` } confirmLabel="Yes" cancelLabel="No" cancelHandler={ actions.popModal } confirmHandler={ gotoJobCost.bind(undefined, newJobCost) } />;

			actions.pushModal({ component: popup });
		}
	}

	function copyJobCostToJobSearch () {
		const popup = <ExistingJobSearch key={jobCost.key} copyHandler= { copyJobCostToNewJob } typeName={ typeName } />;

		actions.popModal();
		actions.pushModal({ component: popup });
	}

	function doDelete (e) {
		const modalKey = 'jobcost-delete-spinner';
		const target = jobCost.contractProxy || jobCost;
		const changeOrder = target.currentChangeOrder;

		e.preventDefault();

		actions.popModal();
		actions.pushModal({ key: modalKey, component: (<Spinner />) });

		if (changeOrder) {
			updateModel(jc => {
				jc.changeOrders.delete(changeOrder.key);
			}, { autoSave: true });

			// TODO: need a better way to do this
			const pathParts = componentServices.router.getPathSegments();
			_postSaveCallback = () => {
				actions.deleteModal({ key: modalKey });
				componentServices.router.replaceHistory('/' + pathParts.slice(0, pathParts.length - 4).join('/'));
			};
		}
		else {
			jobCostActions.deleteJobCost({ jobCost })
				.then(() => {
					const pathParts = componentServices.router.getPathSegments();
					componentServices.router.replaceHistory('/' + pathParts.slice(0, pathParts.length - 2).join('/'));
				})
				.finally(() => {
					actions.deleteModal({ key: modalKey });
				});
		}
	}

	function confirmDelete () {
		const popup = <Confirm title={ `Permanently Delete ${typeName}?` } message={ `Are you sure you want to permanently delete this ${typeName}? This cannot be undone.` } confirmLabel="Permanently Delete" cancelLabel="Cancel" cancelHandler={ actions.popModal } confirmHandler={ doDelete } />;

		actions.popModal();
		actions.pushModal({ component: popup });
	}

	function getPopupButtons (jobCost) {
		const changeOrder = jobCost.currentChangeOrder;
		const sideBarTarget = changeOrder || jobCost;
		const buttons:any[] = [];

		if (jobCost.jobKey && !jobCost.changeOrders.length()) {
			buttons.push({
				className: 'button',
				label: 'Copy in This Job',
				action: copyJobCostInJob
			});

			buttons.push({
				className: 'button',
				label: 'Copy to Another Job',
				action: copyJobCostToJobSearch
			});
		}

		if (jobCost.contractorKey) {
			buttons.push({
				className: 'button',
				label: 'Duplicate',
				action: copyJobCostInContractor
			});
		}

		if (sideBarTarget.allowedContractEdits !== 'none') {
			buttons.push({
				className: 'button delete',
				label: 'Delete',
				action: confirmDelete
			});
		}

		return buttons;
	}

	function handleActionsClick (buttons, e) {
		actions.pushModal({ component: <SidebarActionsPopup target={e.target} buttons={ buttons } typeName={typeName} /> });
	}

	function fetchReport(path, shaper) {
		const { store } = componentServices;
		let job;
		if (!jobCost.jobKey && jobCost.contractorKey) {
			return reportActions.createReportingJobForContractorTemplate(jobCost.contractorKey).then(result => {
				return reportActions.fetchReport({ summaries: [summary], job: result, report: path, shaper: reportActions.templateShaper })
			})
		} else {
			job = getModel({ store, collection: ModelCollection.jobs, key: jobCost.jobKey });
			return reportActions.fetchReport({ summaries: [summary], job: job, report: path, shaper: shaper });
		}
	}

	const viewKey = componentServices.routeParams.viewkey;

	if (!jobCost) { return null; }

	const builder = job && job.builderKey && getModel({ store: componentServices.store, collection: ModelCollection.contractors, key: job.builderKey});

	
	// the render target should always be the proxy if it exists to ensure that the data is properly filtered for the context
	const renderTarget = jobCost.contractProxy || jobCost;

	const sideBarTarget = renderTarget.currentChangeOrder || renderTarget;
	const currentNavItem = _.find(navItems, { key: viewKey });
	const title = sideBarTarget.name || `New ${typeName}`;
	const editPage = currentNavItem ? React.cloneElement(currentNavItem.component, _.assign({ jobCost: renderTarget, updateModel: updateModel, fetchReport: fetchReport, store: props.store, typeName: typeName, summary: summary }, currentNavItem.props)): null;
	const sidebarActions = getPopupButtons(renderTarget);

	return (
		<React.Fragment>
			<ContractorLockSection contractor={ builder } />
			<section className="workflowMenu">
				<header>
					<button className={ sidebarActions.length ? 'popup' : 'popup disabled'} onClick={ sidebarActions.length ? handleActionsClick.bind(undefined, sidebarActions) : undefined }><span><span title={ title }>{ title }</span></span></button>
				</header>
				<div>
					{ summary? <SidebarStatus summary={ summary } />: null }
					<div className="referenceNumbers">{ isCompositeMode? sideBarTarget.relayNumber: `${sideBarTarget.relayNumber} Rev.${sideBarTarget.itemVersion}` }</div>
					{ currentNavItem? <SidebarNav handleNavClick={handleNavClick} navItems={navItems} currentNavItem={currentNavItem} jobCost={renderTarget} />: null }
				</div>
			</section>
			<section className="workflow">
				{ editPage }
			</section>
		</React.Fragment>

	);
}